import { LayoutView } from 'pages/CampaignDetail/components/CampaignLayoutToggler'

// export const DEFAULT_HITS_VIEW: LayoutView = 'grid'
export const DEFAULT_HITS_VIEW: LayoutView = 'table'
